import { render, staticRenderFns } from "./VoucherConsume.vue?vue&type=template&id=12451a74"
import script from "./VoucherConsume.vue?vue&type=script&lang=js"
export * from "./VoucherConsume.vue?vue&type=script&lang=js"
import style0 from "./VoucherConsume.vue?vue&type=style&index=0&id=12451a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports